import { useEffect, useState } from "react";

function diff(target) {
  const t = new Date(target).getTime() - Date.now();
  const clamp = Math.max(t, 0);
  return {
    days: Math.floor(clamp / 86400000),
    hours: Math.floor((clamp % 86400000) / 3600000),
    minutes: Math.floor((clamp % 3600000) / 60000),
    seconds: Math.floor((clamp % 60000) / 1000),
  };
}

export default function Countdown({ target, compact = false }) {
  const [t, setT] = useState(() => diff(target));
  useEffect(() => {
    const id = setInterval(() => setT(diff(target)), 1000);
    return () => clearInterval(id);
  }, [target]);

  const unit = (val, label) => (
    <div className="flex flex-col items-center" data-testid={`countdown-${label}`}>
      <span className={`font-mono gold-text tabular-nums ${compact ? "text-lg" : "text-3xl sm:text-4xl"}`}>
        {String(val).padStart(2, "0")}
      </span>
      <span className="kicker mt-1 text-[0.6rem]">{label}</span>
    </div>
  );

  return (
    <div className={`flex ${compact ? "gap-3" : "gap-5 sm:gap-8"}`} data-testid="countdown-timer">
      {unit(t.days, "days")}
      {unit(t.hours, "hrs")}
      {unit(t.minutes, "min")}
      {unit(t.seconds, "sec")}
    </div>
  );
}
